import React from 'react';

import MultipleChoiceEditor from './MultipleChoice/MultipleChoiceEditor';
import OpenTextEditor from './OpenText/OpenTextEditor';
import MultipleSelectEditor from './MultipleSelect/MultipleSelectEditor';
import MatrixEditor from './Matrix/MatrixEditor';
import HotspotEditor from './Hotspot/HotspotEditor';
import DragAndDropEditor from './DragAndDrop/DragAndDropEditor';
import StimulusEditor from './Stimulus/StimulusEditor';
import type {
    QtiQuestionDTO,
    QtiMultipleChoiceQuestionDTO,
    QtiOpenTextQuestionDTO,
    QtiMultipleSelectQuestionDTO,
    QtiMatrixQuestionDTO,
    QtiHotspotQuestionDTO,
    QtiDragAndDropQuestionDTO,
    QtiGraphingQuestionDTO,
} from '@/src/lib';
import type { QtiStimulusQuestionForEditorDTO } from '../models/questionDTOs';
import NotFoundPage from '@/src/pages/_routing/NotFoundPage';
import { Constants } from '@/src/utils';
import GraphingEditor from './Graphing/GraphingEditor';
const qtm = Constants.QUESTION_TYPE_MASTER_IDS;

interface QuestionControllerProps {
    questionType: number; // number representing question type
    initialModel?: QtiQuestionDTO;
}

export const QuestionController: React.FC<QuestionControllerProps> = ({
    questionType,
    initialModel,
}) => {
    switch (questionType) {
        case qtm.MULTIPLE_CHOICE:
            return (
                <MultipleChoiceEditor initialModel={initialModel as QtiMultipleChoiceQuestionDTO} />
            );
        case qtm.OPEN_TEXT:
            return <OpenTextEditor initialModel={initialModel as QtiOpenTextQuestionDTO} />;
        case qtm.MULTIPLE_SELECT:
            return (
                <MultipleSelectEditor initialModel={initialModel as QtiMultipleSelectQuestionDTO} />
            );
        case qtm.MATRIX:
            return <MatrixEditor initialModel={initialModel as QtiMatrixQuestionDTO} />;
        case qtm.DRAG_AND_DROP:
            return <DragAndDropEditor initialModel={initialModel as QtiDragAndDropQuestionDTO} />;
        case qtm.STIMULUS:
            return (
                <StimulusEditor initialModel={initialModel as QtiStimulusQuestionForEditorDTO} />
            );
        case qtm.HOTSPOT:
            return <HotspotEditor initialModel={initialModel as QtiHotspotQuestionDTO} />;
        case qtm.SEGMENT:
        // Segment
        /* falls through  */
        case qtm.GRAPHING:
            return <GraphingEditor initialModel={initialModel as QtiGraphingQuestionDTO} />;
        case qtm.DYNAMIC:
        // Dynamic (separate component)
        /* falls through  */
        default:
            return <NotFoundPage />;
        // throw new Error("Invalid question type");
    }
};
